import { Box, Collapse, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import { ChevronDown, ChevronUp } from '@wix/wix-ui-icons-common';
import React, { useState } from 'react';
import { FailedElementItem } from './failed-element-item';
export const AffectedContainersList = _ref => {
  let {
    failedElements,
    onElementClick,
    onContainerClick
  } = _ref;
  const {
    t
  } = useTranslation();
  const [isCollapseOpen, setIsCollapseOpen] = useState(false);
  if (!failedElements || failedElements.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "#F6F7F9",
    borderRadius: "10px",
    direction: "vertical",
    display: "flex",
    padding: "0 0 0 SP2"
  }, /*#__PURE__*/React.createElement(Box, {
    align: "space-between",
    cursor: "pointer",
    display: "flex",
    padding: "SP1",
    style: {
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "normal",
    secondary: true,
    onClick: () => {
      setIsCollapseOpen(!isCollapseOpen);
      onContainerClick == null || onContainerClick();
    }
  }, t('accessibility-wizard.rules-list.page-auto-dom-order.view-affected-containers.title', {
    count: failedElements.length
  })), isCollapseOpen ? /*#__PURE__*/React.createElement(ChevronDown, null) : /*#__PURE__*/React.createElement(ChevronUp, null)), /*#__PURE__*/React.createElement(Collapse, {
    open: isCollapseOpen
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP1",
    marginBottom: "SP2",
    marginTop: "SP2",
    paddingRight: "SP2"
  }, failedElements.map((element, index) => {
    const elementData = element;
    const displayName = elementData.semanticName;
    return /*#__PURE__*/React.createElement(FailedElementItem, {
      dataHook: `failed-element-${index}`,
      displayName: displayName,
      key: index,
      onViewClick: () => onElementClick == null ? void 0 : onElementClick(element, index)
    });
  }))));
};
//# sourceMappingURL=affected-containers-list.js.map